export const SignInError = {
  SAML_ERROR: "SAML_ERROR",
  AUTH_FAILED: "AUTH_FAILED",
  PROVIDER_ERROR: "PROVIDER_ERROR",
  ACCOUNT_BLOCKED: "ACCOUNT_BLOCKED",
  MULTI_ACCOUNT_FAILURE: "MULTI_ACCOUNT_FAILURE",
  AUTHENTICATION_REQUIRES_PROVIDER_CONFIRMATION: "AUTHENTICATION_REQUIRES_PROVIDER_CONFIRMATION",
} as const;
